'use strict';

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (schema) {
  while (this.isCollection(schema)) {
    if ((0, _isArray2.default)(schema)) {
      schema = schema[0];
    } else {
      schema = schema.value;
    }
  }

  return schema;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NvdXJjZS9zeXN0ZW0vdW5ib3hDb2xsZWN0aW9uU2NoZW1hLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImV4cG9ydHMiLCJzY2hlbWEiLCJpc0NvbGxlY3Rpb24iLCJ2YWx1ZSJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7OztBQUlBQSxPQUFPQyxPQUFQLEdBQWlCLFVBQVVDLE1BQVYsRUFBbUI7QUFFbkMsU0FBUSxLQUFLQyxZQUFMLENBQW1CRCxNQUFuQixDQUFSLEVBQXNDO0FBRXJDLFFBQUssdUJBQVdBLE1BQVgsQ0FBTCxFQUEyQjtBQUUxQkEsZUFBU0EsT0FBUSxDQUFSLENBQVQ7QUFFQSxLQUpELE1BSU87QUFFTkEsZUFBU0EsT0FBT0UsS0FBaEI7QUFFQTtBQUVEOztBQUVELFNBQU9GLE1BQVA7QUFFQSxDQWxCRCIsInNvdXJjZXNDb250ZW50IjpbIid1c2Ugc3RyaWN0JztcblxuaW1wb3J0IF8gZnJvbSAnbG9kYXNoJztcblxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbiggc2NoZW1hICkge1xuXG5cdHdoaWxlICggdGhpcy5pc0NvbGxlY3Rpb24oIHNjaGVtYSApICkge1xuXG5cdFx0aWYgKCBfLmlzQXJyYXkoIHNjaGVtYSApICkge1xuXG5cdFx0XHRzY2hlbWEgPSBzY2hlbWFbIDAgXTtcblxuXHRcdH0gZWxzZSB7XG5cblx0XHRcdHNjaGVtYSA9IHNjaGVtYS52YWx1ZTtcblxuXHRcdH1cblxuXHR9XG5cblx0cmV0dXJuIHNjaGVtYTtcblxufTsiXX0=